import { memo } from 'react';
import { GameReportBetProps } from './props';
import BetDisplay from './Display';
import styles from './styles.module.scss';
import BetInfo from './Info';
import Divider from '../../Divider';

function GameReportBet({ bet, isPending, isSingleBet }: GameReportBetProps) {
  return (
    <div className={styles.container}>
      <BetInfo bet={bet} isPending={isPending} />
      <Divider secondary />
      <BetDisplay bet={bet} isPending={isPending} isSingleBet={isSingleBet} />
    </div>
  );
}

export default memo(GameReportBet);
